import { createContext } from 'react'

export const ContextMenuContext = createContext()
